import { jwtDecode, JwtPayload } from "jwt-decode";

export function decodeJwt<T extends JwtPayload>(token: string): T {
  try {
    return jwtDecode<T>(token);
  } catch (error) {
    throw new Error("Invalid JWT token");
  }
}
